<template>
    <div class="suscripciones">
        <div class="container">
            <div class="row">
                <h1>Listado de Suscripciones</h1>

                   <div v-for="suscripcion in suscripciones">
                    <h2>Mail: {{suscripcion}} </h2>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

import fireApp from '../services/fireConfig.js'
import { getAllSuscripciones } from '../services/website/website.service.js'

export default {
    name: 'registros',

    data () {
        return {
            suscripciones: null
        }
    },

    created () {
        let cmp = this;

        getAllSuscripciones(function(p) {
            cmp.suscripciones = p;
        });
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Suscripciones.vue?07159846